import { render, staticRenderFns } from "./PurchasesReport.vue?vue&type=template&id=62875d94&scoped=true&"
import script from "./PurchasesReport.vue?vue&type=script&lang=js&"
export * from "./PurchasesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62875d94",
  null
  
)

export default component.exports